module.exports = __webpack_public_path__ + "img/license-count.3ab40621.svg";